export default __webpack_public_path__ + "static/29-weapon-8ab2e073b30feacad477a85c14ab1f98.png";